import { InjectionToken } from "@angular/core";

export const MULTISELECT_FILTER_STATE_PROP = new InjectionToken<string>("MULTISELECT_FILTER_STATE_PROP");
export const multiselectFilterStatePropProvider = {
    provide: MULTISELECT_FILTER_STATE_PROP,
    useValue: "multiselectFilters",
};
